import React from 'react';
import classnames from 'classnames';
import { COMPANY_SIZE_MAP } from '@/constants/global';
import styles from './index.module.scss';

type ProductCaseCardProps = {
  boxProductId: string;
  boxProductCaseId: string;
  width?: number;
  title?: string;
  companyNumEmployee?: number;
  companyAddress?: string;
  companyName?: string;
};

const ProductCaseCard: React.FC<ProductCaseCardProps> = ({
  boxProductId,
  boxProductCaseId,
  width,
  title,
  companyNumEmployee,
  companyAddress,
  companyName,
}) => {
  return (
    <a href={`/cbndatabox-new/product/${boxProductId}/casedetails/${boxProductCaseId}`}>
      <div className={styles.card} style={{ width }}>
        <div>
          <h1 className={classnames(styles.caseTitle, styles.doubleLineEllipsis)}>{title}</h1>
          <p className={styles.companyInfo}>
            {COMPANY_SIZE_MAP[companyNumEmployee] && `${COMPANY_SIZE_MAP[companyNumEmployee]} | `}
            {companyAddress && `${companyAddress} | `}
            {companyName}
          </p>
        </div>
        <div className={styles.navIcon}>
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-product_case_arrow_right"></use>
          </svg>
        </div>
      </div>
    </a>
  );
};
export default ProductCaseCard;
